import { render, staticRenderFns } from "./CardPoint.vue?vue&type=template&id=6422a738&"
import script from "./CardPoint.vue?vue&type=script&lang=js&"
export * from "./CardPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports